module.exports = __webpack_public_path__ + "static/media/ahmad.90704ae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/ahmad.png
// module id = 1653
// module chunks = 0